import {onReactionError} from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';

import {captureException} from 'capture_sentry_exception.js';
import autobind from 'common/decorators/autobind.js';
import FocusManager from 'core/components/FocusManager.js';
import {PracticeStoreContext} from 'core/stores/RootStore.js';
import PracticeContent from 'practices/components/PracticeContent.js';
import PracticeHeader from 'practices/components/PracticeHeader.js';
import PracticeSidebar from 'practices/components/PracticeSidebar.js';
import Tools from 'core/components/Tools.js';
import Modal from 'core/components/Modal.js';
import BookAppointmentModal from 'core/components/BookAppointmentModal.js';
import {
    PAGE_TYPE_PRACTICE_LOCATION,
    PAGE_TYPE_PRACTICE_GROUP,
} from 'core/constants.js';

export default
@observer
class PracticeApp extends React.Component {
    static contextType = PracticeStoreContext;

    constructor(props) {
        super(props);
        onReactionError(captureException);

        this.state = {
            isBookingAppointmentModalOpen: false,
            currentBookAppointmentPractice: null,
        };
    }

    componentDidMount() {
        this.context.updateStore({
            url: this.props.url,
            isPracticeGroup: this.props.isPracticeGroup,
            showAppointmentModal: this.showAppointmentModal,
        });
    }

    @autobind
    showAppointmentModal(practices) {
        this.setState({
            isBookingAppointmentModalOpen: true,
            currentBookAppointmentPractice: practices,
        });
    }

    @autobind
    closeAppointmentModal() {
        this.setState({
            isBookingAppointmentModalOpen: false,
        });
    }

    renderBookAppointmentModal() {
        const activeElement = document.activeElement;
        const {isPracticeGroup} = this.context;
        const {isReferrals} = this.props;

        const {
            name,
            practitioners,
            localityId,
            postCode,
            locality,
        } = this.state.currentBookAppointmentPractice;
        const {id} = practitioners;
        const hasSpecialistSpecialty = practitioners.specialties.find(
            (sp) => sp.isSpecialist,
        );
        const modalData = {
            ...practitioners,
            profileId: id,
            closeModal: this.closeAppointmentModal,
            displayScreenerQuestion: !!hasSpecialistSpecialty,
            isPracticeGroup,
            isReferrals,
        };

        if (isPracticeGroup) {
            const {locations} = practitioners;
            // On the group pages, if only one location for this practitioner
            if (locations.length === 1) {
                modalData.practice = locations[0];
            } else {
                modalData.practice = locations;
            }
        } else {
            const {requestAppointmentEmail} = practitioners;
            modalData.practice = {
                id,
                name,
                localityId,
                postCode,
                locality,
                requestAppointmentEmail,
            };
        }
        return (
            <Modal
                closeModal={this.closeAppointmentModal}
                initElement={activeElement}
                parentElement={activeElement.parentElement}
            >
                <BookAppointmentModal {...modalData} />
            </Modal>
        );
    }

    render() {
        const {
            rootStore: {paramStore},
            displayedModal,
            renderModal,
            isPracticeGroup,
            practice,
            practiceLoaded,
        } = this.context;
        const {isBookingAppointmentModalOpen} = this.state;
        if (!practiceLoaded) {
            return null;
        }
        return (
            <>
                <FocusManager />
                <PracticeHeader />
                <PracticeContent />
                <PracticeSidebar />
                <Tools
                    availableCategories={[
                        'Address',
                        'Phone number',
                        'practitioners',
                        'Other',
                    ]}
                    displayName={practice.name}
                    isClient={paramStore?.isClient}
                    pageType={
                        isPracticeGroup
                            ? PAGE_TYPE_PRACTICE_GROUP
                            : PAGE_TYPE_PRACTICE_LOCATION
                    }
                />
                {displayedModal && renderModal()}
                {isBookingAppointmentModalOpen &&
                    this.renderBookAppointmentModal()}
            </>
        );
    }
}
